var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33.9394,
    height: 33.9394,
    transform: "translate(0.0593262)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1509_300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.726 26.6667H10.3703C9.36319 26.6667 8.54419 25.8513 8.54419 24.8487V7.27274H10.3642V23.079C11.0801 21.6596 12.2206 19.4672 13.4825 17.311C17.4683 10.4799 19.2276 9.71283 20.4288 9.85175C21.0719 9.93027 21.9151 10.3833 22.2731 12.1046C22.4369 12.8958 22.5764 13.6146 22.7099 14.2729C23.5349 18.4948 23.814 19.9141 26.2649 21.4664L25.2882 22.9945C22.1821 21.0255 21.7877 19.0202 20.9263 14.6172C20.7989 13.9649 20.6593 13.2461 20.4955 12.467C20.356 11.7785 20.174 11.6275 20.1679 11.6275C18.9789 11.6275 14.9688 17.7277 11.5169 24.8426H26.726V26.6606V26.6667Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1509_300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1818,
    height: 19.3939,
    fill: "white",
    transform: "translate(8.54419 7.27274)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLdd);
export default __webpack_public_path__ + "static/media/ldd.a33485286c0dfb8668a5eb79042f99a0.svg";
export { ForwardRef as ReactComponent };